const Form083EN = {
    stepName: {
        importantNotes: "Important Notes",
        teacherFillInTheSupplementary:
            "Supplementary Sheet\n(To be completed by the teacher)",
        schoolOfInformation:
            "School Admin fill in the form of Regrading to Graduate Teachers in Primary Schools",
        certification: "Certification",
        // changesInSalaryDetails: "Acting Appointment Details",
        // salaryParticulars: "Certification",
        // noteInformation: "Note information",
        // attachment: "Attachment",
        confirmation: "Confirmation",
        detailsOfRegrading: "Details of Regrading",
        approverCertification: "Certification",
        annex: "Annex for Staff Establishment and Strength Table",
        formA: "Certification",
        formB: "Basic Information",
    },
    label: {
        header: {
            headerOne: "Important Notes",
        },
        statement:
            "I have read the “Personal Information Collection Statement” and fully understand its conten.",
        iamSignCheck:
            "I understand that an “iAM Smart+” account is required for processing the application.",
        certificationCheckboxText:
            "I confirm that the particulars in the supplementary sheet are correct and complete.",
        pointOption: {
            fortyNine: "49",
            fortyEight: "48",
            fortySeven: "47",
            fortySix: "46(44B)",
            fortyFive: "45(44A)",
            fortyFour: "44",
            fortyThree: "43",
            fortyTwo: "42",
            fortyOne: "41",
            forty: "40",
            thirtyNine: "39",
            thirtyEight: "38",
            thirtySeven: "37",
            thirtySix: "36(33C)",
            thirtyFive: "35(33B)",
            thirtyFour: "34(33A)",
            thirtyThree: "33",
            thirtyTwo: "32",
            thirtyOne: "31",
            thirty: "30",
            twentyNine: "29",
            twentyEight: "28",
            twentySeven: "27",
            twentySix: "26",
            twentyFive: "25",
            twentyFour: "24",
            twentyThree: "23",
            twentyTwo: "22",
            twentyOne: "21",
            twenty: "20",
            nineteen: "19",
            eighteen: "18",
            seventeen: "17",
            sixteen: "16",
            fifteen: "15",
            fourteen: "14",
            thirteen: "13",
            twelve: "12",
            eleven: "11",
            ten: "10",
            nine: "9",
            eight: "8",
            seven: "7",
            six: "6",
            five: "5",
            four: "4",
            three: "3",
            two: "2",
            one: "1",
            zero: "0",
        },
        schoolSessionOption: {
            am: "AM",
            pm: "PM",
            wholeDay: "Whole Day",
        },
        committeeOption: {
            smc: "School Management Committee",
            imc: "Incorporated Management Committee",
        },

        teacherFillInTheSupplementary: {
            header: "Supplementary Sheet for Regrading to Graduate Teachers in Primary Schools",
            header1:
                "(To be completed by the teacher if the salary upon regrading is determined by re-assessment)",
            schoolName1: "School Name",
            schoolCode1: "School Code",
            information: "Basic Information",
            personalInformation: "Personal Particular",
            // personalInformation: "(i) Personal Particulars",
            title: "Title",
            titleOption: {
                Mr: "Mr",
                Miss: "Miss",
                Mrs: "Mrs",
                Ms: "Ms",
            },
            nameInEnglish: "Name of Teacher in English",
            nameInChinese: "Name of Teacher in Chinese",
            hkid1: "HKIC No.",
            srn1: "Staff Reference Number",
            appointmentParticulars: "Appointment Particulars ",
            appointmentParticulars1:
                "(Use a separate sheet if necessary. For non-local academic qualifications and/or professional training, provide the assessment results and/or other relevant details.)",
            academicQualifications: "Academic Qualifications",
            collegeOrUniversityOrInstitute: "College/University/Institute",
            certificateOrDiplomaOrDegreeObtained:
                "Certificate/Diploma/Degree obtained",
            dateOfAward: "Date of Award(DD)",
            dateOfAwardmm: "Date of Award(MM)",
            dateOfAwardyy: "Date of Award(YYYY)",
            dateOfAwardMmList: {
                jan: "01",
                feb: "02",
                mar: "03",
                apr: "04",
                may: "05",
                jun: "06",
                jul: "07",
                aug: "08",
                sep: "09",
                oct: "10",
                nov: "11",
                dec: "12",
            },
            dateOfAwardList: {
                1: "01",
                2: "02",
                3: "03",
                4: "04",
                5: "05",
                6: "06",
                7: "07",
                8: "08",
                9: "09",
                10: "10",
                11: "11",
                12: "12",
                13: "13",
                14: "14",
                15: "15",
                16: "16",
                17: "17",
                18: "18",
                19: "19",
                20: "20",
                21: "21",
                22: "22",
                23: "23",
                24: "24",
                25: "25",
                26: "26",
                27: "27",
                28: "28",
                29: "29",
                30: "30",
                31: "31",
            },
            majorAndMinorSubjects: "Major & Minor Subject(s)",
            professionalTraining: "Professional Training",
            schoolOrCollegeOrUniversityOrInstitute:
                "School/College/University/Institute",
            certificateOrDiplomaOrDegreeObtained1:
                "Certificate/Diploma/Degree obtained",
            dateOfAward1: "Date of Award(DD)",
            dateOfAward1mm: "Date of Award(MM)",
            dateOfAward1yy: "Date of Award(YYYY)",
            courseOrSubject: "Course/Subject",
            teachingExperience: "Teaching Experience",
            schoolOrInstitute: "School/Institute",
            type: "Type",
            rank: "Rank",
            form: "From(dd/mm/yyyy)",
            to: "To(dd/mm/yyyy)",
            fullOrPartTime: "Full- or Part-time",
            fullOrPartTimeOption: {
                full: "Full-time",
                partTime: "Part-time",
            },
            partTime: "If part-time, please state the fraction",
            sourceOfFunding: "Source of Funding",
            tooltip: {
                tooltip1:
                    "Please specify, e.g. Aided, Govt, Private, Caput, BPS, DSS…..",
                tooltip2: "If part-time, please state the fraction.",
                tooltip3:
                    "Please specify, e.g. Salaries Grant (SG), Quality Education Fund (QEF), Operating Expenses Block Grant (OEBG), Capacity Enhancement Grant (CEG),private …..",
            },
            noPayLeaveTaken: "No-pay Leave Taken (If any)",
            schoolOrInstitute1: "School/Institute",
            form1: "From(dd/mm/yyyy)",
            to1: "To(dd/mm/yyyy)",
            note: "I confirm that the particulars above are correct and complete.",
            date: "Date",
            signatureOfTeache: "Signature of Teache",
            note1: "I have checked the completeness of the information in the Supplementary Sheet and verified it in accordance with the requirements of the relevant Code of Aid. I understand that EDB will not process this form if it contains incomplete information. ",
            note2: "I confirm that the salary assessment in respect of the relevant staff is correct.",
            supervisorOrSchoolHead: "Supervisor / School Head",
            supervisorOrSchoolHeadOption: {
                supervisor: "Supervisor",
                schoolHead: "School Head",
            },
            nameOfSchoolSupervisorOrSchoolHead:
                "Name of School Supervisor / School Head",
            nameDescription: "Name (as printed on HK Identity Card)",
        },

        schoolOfInformation: "School of Information",
        titleNote: {
            note1: "Original & Duplicate",
            note2: "- Funds Section, Education Bureau",
            note3: "- Central Salary Verification Team, Education Bureau (c/o Funds Section)",
            note4: "Triplicate",
            note5: "- Respective Regional Education Office [Attn :",
            note6: "Education Bureau",
            note7: "Quadruplicate",
            note8: "- School's Record",
        },
        ssdoOption: {
            Central_and_Western: "Central & Western District",
            Southern: "Southern District",
            Wan_Chai: "Wan Chai District",
            Islands: "Islands District",
            HKEast: "Hong Kong East District",
            Kowloon_City: "Kowloon City District",
            Sham_Shui_Po: "Sham Shui Po District",
            Sai_Kung: "Sai Kung District",
            Kwun_Tong: "Kwun Tong District",
            Wong_Tai_Sin: "Wong Tai Sin District",
            Yau_Tsim_Mong: "Yau Tsim Mong District",
            Tai_Po: "Tai Po District",
            North: "North District",
            Sha_Tin: "Sha Tin District",
            Kwai_Chung_and_Tsing_Yi: "Kwai Chung & Tsing Yi District",
            Tsuen_Wan: "Tsuen Wan District",
            Tuen_Mun: "Tuen Mun District",
            Yuen_Long: "Yuen Long District",
        },
        ssdo: "SSDO",
        schoolName: "School Name",
        schoolCode: "School Code",
        schoolSession: "School Session",
        // schoolContactPerson: "School’s Contact person",
        tel: "Telephone Number",
        contactAndTelText1: "School's contact person",
        contactAndTelText2: "and tel. no.",
        contactAndTelText3: "(for enquiry by EDB in processing this form)",
        detailsOfRegrading: "Details of Regrading",
        committee: "Committee",
        mode: " has approved the following acting appointment",
        ref: "Reference Number",
        date: "Date",
        committeeText1: "1. The ",
        committeeText2: "has approved the following regrading (Ref. No.",
        committeeText3: "and Date:",
        committeeText4: ")",
        committeeText5: " and the consequential change in salary particulars:",
        // two page
        changesInSalaryDetails: "Acting Appointment Details",
        englishName: "Name of Teacher in English",
        chineseName: "Name of Teacher in Chinese",
        hkid: "HKID No.",
        srn: "SRN",
        beforeRegrading: "Before Regrading",
        monthlySalary: "Monthly Salary (MPS point) Before Regrading",
        // monthlySalaryOption: {
        //     SalaryList: {
        //         0: "12,915",
        //         1: "13,735",
        //         2: "14,600",
        //         3: "15,560",
        //         4: "16,565",
        //         5: "17,675",
        //         6: "18,795",
        //         7: "20,035",
        //         8: "21,340",
        //         9: "22,725",
        //         10: "24,070",
        //         11: "25,545",
        //         12: "27,145",
        //         13: "28,780",
        //         14: "30,235",
        //         15: "31,750",
        //         16: "33,350",
        //         17: "35,040",
        //         18: "36,765",
        //         19: "38,595",
        //         20: "40,515",
        //         21: "42,545",
        //         22: "44,555",
        //         23: "46,655",
        //         24: "48,860",
        //         25: "51,095",
        //         26: "53,500",
        //         27: "55,995",
        //         28: "58,635",
        //         29: "61,415",
        //         30: "64,270",
        //         31: "67,295",
        //         32: "70,465",
        //         33: "73,775",
        //         34: "74,515",
        //         35: "75,265",
        //         36: "78,385",
        //         37: "82,105",
        //         38: "85,870",
        //         39: "89,845",
        //         40: "93,710",
        //         41: "97,745",
        //         42: "101,965",
        //         43: "106,340",
        //         44: "110,170",
        //         45: "117,580",
        //         46: "121,790",
        //         47: "126,220",
        //         48: "130,760",
        //         49: "135,470",
        //     },
        // },
        rank: "Rank Before Regrading",
        uponRegrading: "Upon Regrading",
        monthlySalary1: "Monthly Salary (MPS point) Upon Regrading",
        monthlySalaryTemp: "Monthly Salary",
        mps: "(MPS Pt.)",
        rank1: "Rank upon Regrading",
        // substantiveRank: "Substantive Rank",
        actingPeriod: "Acting Period",
        effectiveDate: "Effective Date (dd/mm/yyyy)",
        incrementalDate: "Incremental Date (01/mm)",
        incrementalDateList: {
            0: "N/A",
            1: "01",
            2: "02",
            3: "03",
            4: "04",
            5: "05",
            6: "06",
            7: "07",
            8: "08",
            9: "09",
            10: "10",
            11: "11",
            12: "12",
        },
        dateOfNextIncrement: "Date of Next Increment (01/mm/yyyy)",
        salaryBar: "Salary Bar (if applicable)(MPS Pt)",
        // salaryBarOption: {
        //     na: "Na",
        //     0: "0",
        //     1: "1",
        //     2: "2",
        //     3: "3",
        //     4: "4",
        //     5: "5",
        //     6: "6",
        //     7: "7",
        //     8: "8",
        //     9: "9",
        //     10: "10",
        //     11: "11",
        //     12: "12",
        //     13: "13",
        //     14: "14",
        //     15: "15",
        //     16: "16",
        //     17: "17",
        //     18: "18",
        //     19: "19",
        //     20: "20",
        //     21: "21",
        //     22: "22",
        //     23: "23",
        //     24: "24",
        //     25: "25",
        //     26: "26",
        //     27: "27",
        //     28: "28",
        //     29: "29",
        //     30: "30",
        //     31: "31",
        //     32: "32",
        //     33: "33",
        //     34: "34",
        //     35: "35",
        //     36: "36",
        //     37: "37",
        //     38: "38",
        //     39: "39",
        //     40: "40",
        //     41: "41",
        //     42: "42",
        //     43: "43",
        //     44: "44",
        //     45: "45",
        //     46: "46",
        //     47: "47",
        //     48: "48",
        //     49: "49",
        // },
        salaryBarOption: {
            fortyNine: "49",
            fortyEight: "48",
            fortySeven: "47",
            fortySix: "46(44B)",
            fortyFive: "45(44A)",
            fortyFour: "44",
            fortyThree: "43",
            fortyTwo: "42",
            fortyOne: "41",
            forty: "40",
            thirtyNine: "39",
            thirtyEight: "38",
            thirtySeven: "37",
            thirtySix: "36(33C)",
            thirtyFive: "35(33B)",
            thirtyFour: "34(33A)",
            thirtyThree: "33",
            thirtyTwo: "32",
            thirtyOne: "31",
            thirty: "30",
            twentyNine: "29",
            twentyEight: "28",
            twentySeven: "27",
            twentySix: "26",
            twentyFive: "25",
            twentyFour: "24",
            twentyThree: "23",
            twentyTwo: "22",
            twentyOne: "21",
            twenty: "20",
            nineteen: "19",
            eighteen: "18",
            seventeen: "17",
            sixteen: "16",
            fifteen: "15",
            fourteen: "14",
            thirteen: "13",
            twelve: "12",
            eleven: "11",
            ten: "10",
            nine: "9",
            eight: "8",
            seven: "7",
            six: "6",
            five: "5",
            four: "4",
            three: "3",
            two: "2",
            one: "1",
            zero: "0",
            na: "N/A",
        },
        maxSalary: "Maximum Salary (MPS Pt)",
        certification: "Certification",
        declaration:
            "2. I declare that a graduate teacher vacancy is available for the above regrading through the following means (please put a “ √ ” where appropriate) –",
        declarationList: {
            declaration1: "The  ",
            declaration2:
                "The student guidance teacher is regraded using the graduate teacher post provided at sponsor level.",
        },
        declaration1: {
            declaration2:
                " is regraded using the graduate teacher post entitled by the school. The Staff Establishment and Strength Table at the ",
            declaration3: "Annex",
            declaration4:
                " indicates that a vacancy is available for the above regrading.",
        },

        teacherOrstudent: {
            teacher: "Teacher",
            student: "Student guidance teacher",
        },
        note: "3. I confirm that the particulars in paragraphs 1 to 2 of this form and the supplementary sheet are correct. I undertake that the regrading will not result in having the number of graduate teachers in excess of our graduate post entitlement. I also undertake that my school shall refund anyover-payment of Salaries Grant to the Education Bureau.",
        personalStatement: "Statement",
        title: "Personal Information Collection Statement",
        chooseTheSchool:
            "Annex for School (For Ordinary Primary School/ For Special School)",
        chooseTheSchoolOption: {
            primarySchool: "Primary School",
            specialSchool: "Special School",
        },
        attachmentForSchool: "Attachment for {{school}}",
        attachment: "Attachment",
        // attachment: "Annex for Staff Establishment and Strength Table",
        attachmentLink: "Click here to download the Annex form",
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        confirm: "Confirm",
        collectionStatement: "Personal Information Collection Statement",
        completedBySchoolHead:
            "To be completed by the Supervisor / School Head",
        dialogText: "Please select the school first",
    },
    note: {
        note1: "The personal data provided in this form will be used by the Education Bureau for one or more of the following purpose(s):",
        note2: "Please use one form for each regrading.",
        note3: "Please complete the Supplementary Sheet if the salary upon regrading is determined by re-assessment",
        note3a: ".",
        note3b: "Please read the Personal Information Collection Statement carefully before completing this form.",
        note4: "Please ensure the content of this form and the supplementary sheet, if applicable, is made known to the teacher and he/she has read the Personal Information Collection Statement.",
        // note5: "1.All the necessary procedures for promoting a teacher or making acting appointment should be completed before the effective date, including the approval by the SMC/IMC. Under normal circumstances, there should be no retrospective effect for the date of promotion and acting appointment.",
        // note6: "2.For secondary schools, secondary special schools or the secondary section of combined level special schools, a full-time regular PGM/SGM/GM who has been recommended and approved to take up the functional duties of a higher office in the rank of PI/PII/PGM/SGM as appropriate on an acting basis for a qualifying period of not less than 30 calendar days will be entitled to draw an acting allowance.",
        // note7: "3.If leave exceeding 3 consecutive working days affects the calculation of the qualifying period and/or involves the forfeiture of acting allowance for the whole period of leave of the teacher on the acting appointment to eligible ranks (including leave and intervening public holidays and Sundays), please inform this Bureau for adjustment of acting allowance by completing the Acting Appointment Form (Notification for Adjustment of Acting Allowance of Teacher on Acting Appointment Taking Leave/Absence for More than 3 Consecutive Days).",
        // note8: "4.For details, please refer to the Appendix attached to EDB Circular No.8/2004, Should there be a change in the acting up rate, please complete Acting Appointment Form(Notification of Change in Acting-up Rate from 90% to 100%).",
        // note9: "5.Starting from the 2019/20 school year, under full implementation of the all-graduate teaching force policy, all teaching posts on the approved establishment of aided schools are graduate teacher posts.  Starting from the 2019/20 school year, the promotion mechanism for the non-graduate grade will cease to operate.  In other words, there should not be any new promotion and acting appointment(for substantive appointment) in the non-graduate grade.",
        note10: "6.EDB will perform pre-processing entitlement checking on each acting appointment.  If the acting appointment of staff would exceed the approved entitlement of teaching staff of the school on the relevant acting appointment date, no Salaries Grant with respect to that acting appointment will be paid to the school until the acting appointment is confirimed in order.",
        //
        note11: "2. The Staff Establishment and Strength Table at the Annex indicates that a vacancy is available for the above acting appointment.",
        note12: "3. For acting appointment to the post of school head, please provide details of prior approval sought from Education Bureau(File Ref.No.and Date:",
        note12Last: ").",
        note13: "4. I shall inform your Bureau accordingly once the above teacher is confirmed to substantive appointment",
        note13b: " and shall also submit the ‘Staff Promotion’ form.",
        note14: "5. I undertake that if the above teacher’s acting period cannot meet the requirements of qualifying period for granting acting allowance",
        note14b:
            " as specified in paragraph 2 of EDB Circular No. 8/2004, I shall advise the Funds Section of your Bureau promptly with a copy to the respective school development officer.",
        note15: "6. I confirm that the particulars in paragraphs 1 to 3 of this form are correct. I undertake that the acting appointment will not result in having the number of staff holding the posts at the promotion ranks in excess of our approved entitlement. I also undertake my School shall refund any over-payment of the salaries grant to the Education Bureau.",
        //
        // note16: "processing employment-related matters;",
        // note17: "processing Salaries Grant payment and calculation of provident fund contribution and donation;",
        // note18: "auditing;",
        // note19: "conducting research and compiling statistics to facilitate planning of education services;",
        // note20: "processing matters relating to the development of the education profession;",
        // note21: "administering and enforcing the Education Ordinance and Regulations and the Grant/Subsidized Schools Provident Fund Rules(Cap. 279).",
        a: "processing employment-related matters;",
        b: "processing payment of Salaries Grant and other government funding;",
        c: "calculation of provident fund contribution;",
        d: "auditing;",
        e: "conducting research and compiling statistics to facilitate planning of education services;",
        f: "processing matters relating to the development of the education profession;",
        g: "administering and enforcing stipulations under the relevant Code of Aid, Education Ordinance, Education Regulations and the Grant/Subsidized Schools Provident Fund Rules.",
        note22: "The provision of personal data by means of this form is obligatory. Failure to provide these data may affect the processing and outcome of your application.",
        note23: "The personal data collected in this form may be disclosed to other government bureaux/departments/agencies authorized to process such information for the purposes mentioned above.",
        note24: "You have a right to request access to and correction of your personal data as provided in Sections 18 and 22 and Data Protection Principle 6 of Schedule 1 of the Personal Data (Privacy) Ordinance. Your right of access includes the right to obtain a copy of your personal data provided in this form. This is however subject to payment of a fee.",
        note25: "Enquiries concerning the personal data collected by means of this form, including making of access and corrections, should be made in writing to the respective Senior School Development Officer.",
        // five page
    },
    noteList: {
        noteOne:
            "By re-assessment, the salary is assessed on the basis of prevailing starting salaries plus incremental credits for experience (ICE), if applicable.",
        noteTwo:
            "All the necessary procedures for regrading should be completed before the effective date, including the approval by the SMC/IMC. Under normal circumstances,there should be no retrospective effect for the date of regrading.",
        noteThree:
            "EDB will perform pre-processing entitlement checking on each regrading. If the regrading of teacher would exceed the approved entitlement of teaching staff of the school on the relevant regrading date, no Salaries Grant with respect to that regrading will be paid to the school until the regrading is confirmed in order.",
    },
    errorMsg: {
        E001: "Monthly Salary  should <=  Maximum Salary",
        E002: "The two can not be chosen at the same time",
        englishName: "Please input a valid name of teacher in English",
        chineseName: "Please input a valid name of teacher in Chinese",
        numberOnly: "Please input a valid number with 8 digits",
        monthlySalary: "Please input a valid  monthly salary",
        rank: "Please input a valid rank ",
        // monthlySalary1: "Please input a valid substantive rank",
        // rank1: "Please input a valid rank of acting appointment",
        refNum: "Please input a valid reference number",
        hkidEmpty: "The value in the brackets cannot be empty",
        Note001:
            "Note 1.All the necessary procedures for promoting a teacher or making acting appointment should be completed before the effective date, including the approval by the SMC/IMC.  Under normal circumstances, there should be no retrospective effect for the date of promotion and acting appoint.",
        telMax: "Telephone number must be at most 12 digits",
        srnMin: "staff reference number must be 8 digits",
        schoolCodeMin: "school code must be 4 digits",
    },
};
export default Form083EN;
